<template>
  <div class="main">
    <div class="content">
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="query"
        label-width="125px"
      >
        <el-form-item
          label="手机号码"
          style="margin-top: 20px"
          prop="phoneNumber"
        >
          <el-input
            v-model="query.phoneNumber"
            placeholder="请输入手机号(手机号码将作为登录账号)"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="图片验证"
          style="margin-bottom: 40px; height: 40px; line-height: 40px"
          prop="picCode"
        >
          <el-input
            v-model="query.picCode"
            placeholder="请输入图片验证码"
            style="width: 200px"
          ></el-input>
          <!-- <el-col :span="11">
            <el-input
              v-model="query.picCode"
              placeholder="请输入图片验证码"
              style="width: 200px"
            ></el-input>
          </el-col> -->
          <!-- <el-col style="margin-left: 10px;"> -->
          <img class="picCode" @click="getCode" :src="picCodeURL" alt="" />
          <!-- </el-col> -->
        </el-form-item>
        <el-form-item label="短信验证" prop="actCode" style="width: 500px">
          <el-input
            v-model="query.actCode"
            placeholder="请输入短信验证码"
            style="width: 200px"
          ></el-input>
          <el-button
            style="margin-left: 20px"
            type="primary"
            plain
            :disabled="isSend"
            @click="sendCode"
            >{{ sendmsg }}</el-button
          >
          <span v-if="noGetCode" class="noget">未收到短信验证码?</span>
        </el-form-item>
        <el-form-item style="margin: 8% 0 0 10%">
          <el-button
            style="width: 120px"
            type="primary"
            size=""
            autofocus
            :disabled="!checked"
            @click="register()"
            >下一步</el-button
          >
          <!-- <el-button
            style="margin-left: 20px; width: 120px"
            size=""
            @click="cancel()"
            >取消</el-button
          > -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validatePhone, validateActCode } from "@/utils/validate.js";
import {
  handleQRcode,
  handleSendsms,
  handlePhoneexist,
} from "@/api/register/index.js";
import Messages from "@/utils/message.js";
export default {
  props: {},
  data() {
    return {
      isSend: false,
      sendmsg: "获取验证码",
      timeFun: null,
      captchaKey: "", //图片验证码对应key
      cacheKey: true, //获取短信验证后返回值
      picCodeURL:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.hjunkel.com%2Fimages%2Fnopic2.gif&refer=http%3A%2F%2Fwww.hjunkel.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1654141356&t=a0695b22c7b2a1a98bef13907b14a75e",
      checked: true,
      noGetCode: false,
      query: {
        phoneNumber: "",
        picCode: "",
        actCode: "",
      },
      rules: {
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        picCode: [
          { required: true, message: "请输入图片验证码", trigger: "blur" },
        ],
        actCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { validator: validateActCode, trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getCode();
  },
  methods: {
    // 获取图片验证码5分钟有效
    async getCode() {
      console.log("调取验证码接");
      const { result, data } = await handleQRcode();
      if (result == "000000" && data) {
        this.picCodeURL = `data:image/png;base64,${data.imageBase64}`;
        this.captchaKey = data.captchaKey;
      }
    },
    //  验证手机号码
    async sendCode() {
      if (this.query.phoneNumber == "") {
        this.$message({
          type: "error",
          message: "请输入手机号码",
        });
        return;
      } else if (this.query.picCode == "") {
        this.$message({
          type: "error",
          message: "请输入图片验证码",
        });
        return;
      }
      let params = {
        phoneNumber: this.query.phoneNumber, //手机号
        picCode: this.query.picCode, //图片验证码
        captchaKey: this.captchaKey, //验证码key
        loginPlatformCode:
          sessionStorage.getItem("loginPlatformCode") || "888880", //实体平台码
      };
      const { result, data, desc } = await handleSendsms(params);
      if (result == "000000" && data) {
        this.startTimer();
        this.cacheKey = data.cacheKey;
        sessionStorage.cacheKey = data.cacheKey;
        sessionStorage.phoneNumber = this.query.phoneNumber;
      } else {
        this.$message({
          type: "error",
          message: desc + ",注意区分大小写",
        });
      }
    },
    startTimer() {
      this.noGetCode = true;
      this.isSend = true;
      let timer = 60;
      this.sendmsg = timer + "秒后重新发送";
      this.timeFun = setInterval(() => {
        --timer;
        this.sendmsg = timer + "秒后重新发送";
        if (timer == 0) {
          this.isSend = false;
          this.sendmsg = "重新发送";
          clearInterval(this.timeFun);
        }
      }, 1000);
    },
    //  通过手机号码进行验证
    async register() {
      this.$refs["rulesForm"].validate(async (valid) => {
        if (valid) {
          let params = {
            phoneKey: this.cacheKey, //发送验证码后返回的key
            actCode: this.query.actCode, //短信验证码
          };
          const { result, data, desc } = await handlePhoneexist(params);
          //  resultType-1)账号存在有权限 返回状态1+免密登录返回登录会话id (前端进入课后服务首页);
          //  resultType-2)账号存在没机构, 返回状态2(前端进入不是管理员页面);
          //  resultType-3)不存在, 返回状态3(前端进入创建机构信息提交页面);
          if (result === "000000" && data) {
            sessionStorage.registerKey = data.registerKey
              ? data.registerKey
              : "";
            // console.log("创建机构成功", data);
            if (data.resultType == "1" && data.usessionId) {
              // this.$confirm(
              //   "该账户已注册过，确定是否继续注册机构，否则点击取消直接登录课后服务系统",
              //   "提示",
              //   {
              //     confirmButtonText: "确定",
              //     cancelButtonText: "取消",
              //     type: "warning",
              //   }
              // )
              //   .then(() => {
              //     this.$emit("changeStep", 2);
              //   })
              //   .catch(() => {
              //     window.location.href = `https://assfe.tianyuyun.com/?usessionId=${data.usessionId}`;
              //   });
                 window.location.href = `https://assfe.tianyuyun.com/?usessionId=${data.usessionId}`;
            } else {
              this.$emit("changeStep", 2);
            }
            // else if (data.resultType == "2") {
            //   // 账号存在没有机构(游客身份)
            //   // sessionStorage.userType = 'tourist';
            //   // this.$emit("changeStep", 5);
            // } else if (data.resultType == "3") {
            //   sessionStorage.registerKey = data.registerKey;
            //   this.$emit("changeStep", 2);
            // }
          } else {
            this.$message({
              type: "error",
              message: desc,
            });
          }
        } else {
          Messages.error({
            message: "请输入必填项",
            duration: 1000,
          });
        }
      });
    },
    cancel() {
      var domain = sessionStorage.getItem("domain");
      window.open(
        `${domain}/index.php?r=portal/user/logout&service=${domain}`,
        "_self"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 4%;
  .content {
    width: 650px;
    .el-form {
      width: 550px;
      margin: 0 auto;
    }
    .picCode {
      width: 100px;
      height: 40px;
      margin-left: 30px;
      cursor: pointer;
    }
    .noget {
      margin-left: 10px;
      cursor: pointer;
      color: #606266;
    }
    span:hover {
      color: #409eff;
    }
  }
}

::v-deep .el-form .el-input__inner {
  // width: 450px;
  height: 40px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
</style>
